module.exports = __webpack_public_path__ + "img/denuncia_bg.6ace22e2.jpg";